import React, { useEffect, useState } from "react";
import Navbar from "../../Homepage/Navbar";
import Styles from "./coursedetails.module.css";
import course from "../../../Assets/homepage/window.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import react from "../../../Assets/homepage/window.svg";
import displayRazorpay from "../../../razerpay/razorpay";
import axios from "axios";

function CourseDetails() {
  const [data, setData] = useState(null);

  useEffect(() => {
    // alert(window.location.pathname.replace("/coursedetails/",""))
    axios
      .get(
        `https://edflixforus.herokuapp.com/course/${window.location.pathname.replace(
          "/coursedetails/",
          ""
        )}`
      )
      .then((res) => {
        setData(res.data);
      });
  }, []);

  return (
    data && (
      <div class={Styles.majorContainer}>
        <Navbar />
        <div className={Styles.container}>
          <h1 className={Styles.heading}>About Course</h1>
          <div className={Styles.main}>
            <div className={Styles.fulldetails}>
              <img src={course} />
              <div className={Styles.details}>
                <h1>{data.title}</h1>
                <h6>Full Frontend With React</h6>
                <p>₹1200</p>
                <div className={Styles.stars}>
                  <FontAwesomeIcon
                    icon={faStar}
                    className={Styles.iconYellow}
                  />
                  <FontAwesomeIcon
                    icon={faStar}
                    className={Styles.iconYellow}
                  />
                  <FontAwesomeIcon
                    icon={faStar}
                    className={Styles.iconYellow}
                  />
                  <FontAwesomeIcon
                    icon={faStar}
                    className={Styles.iconYellow}
                  />
                  <FontAwesomeIcon icon={faStar} className={Styles.iconGrey} />
                  <p>4/5</p>
                </div>
                {/* <p className={Styles.experience}>Experience: <span>5yrs</span></p> */}
                <div className={Styles.button}>
                  <button className={Styles.btn}>View demo</button>
                  <button
                    className={Styles.btn}
                    style={{ background: "#5CC9FF" }}
                    onClick={displayRazorpay}
                  >
                    Get Course
                  </button>
                </div>
              </div>
            </div>
            <p className={Styles.about}>{data.description}</p>
          </div>
          {/* <div className={Styles.tut}>
                    <h1 className={Styles.demo}>DEMO</h1>
                    <div style={{ "paddingTop": "1vh" }}>
                        <div className={Styles.cards}>
                            <div className={Styles.card}>
                                <img src={react} alt="plank" />
                                <h3>How To Perform Perfect Plank?</h3>
                            </div>
                            <div className={Styles.card}>
                                <img src={react} alt="plank" />
                                <h3>How To Perform Perfect Plank?</h3>
                            </div>
                        </div>
                        <div className={Styles.cards} style={{ "marginTop": "-2vh" }}>
                            <div className={Styles.card}>
                                <img src={react} alt="plank" />
                                <h3>How To Perform Perfect Plank?</h3>
                            </div>
                            <div className={Styles.card}>
                                <img src={react} alt="plank" />
                                <h3>How To Perform Perfect Plank?</h3>
                            </div>
                        </div>
                    </div>
                </div> */}
        </div>
      </div>
    )
  );
}

export default CourseDetails;
